// extracted by mini-css-extract-plugin
export default {"header":"BlockchainHeader_header__jaX3I","spin":"BlockchainHeader_spin__hXW3U"};